/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { NewWorkflowConditionPublishedWorkflowItem } from '../models/new-workflow-condition-published-workflow-item';
import { WorkflowConditionPublishedWorkflowItem } from '../models/workflow-condition-published-workflow-item';
import { WorkflowConditionPublishedWorkflowItemWithRelations } from '../models/workflow-condition-published-workflow-item-with-relations';

@Injectable({
  providedIn: 'root',
})
export class WorkflowConditionPublishedWorkflowItemControllerService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation workflowConditionPublishedWorkflowItemControllerFindById
   */
  static readonly WorkflowConditionPublishedWorkflowItemControllerFindByIdPath = '/workflow-condition-published-workflow-items/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findById()` instead.
   *
   * This method doesn't expect any request body.
   */
  findById$Response(params: {
    id: string;
    filter?: any;
  }): Observable<StrictHttpResponse<WorkflowConditionPublishedWorkflowItemWithRelations>> {

    const rb = new RequestBuilder(this.rootUrl, WorkflowConditionPublishedWorkflowItemControllerService.WorkflowConditionPublishedWorkflowItemControllerFindByIdPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
      rb.query('filter', params.filter, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkflowConditionPublishedWorkflowItemWithRelations>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `findById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findById(params: {
    id: string;
    filter?: any;
  }): Observable<WorkflowConditionPublishedWorkflowItemWithRelations> {

    return this.findById$Response(params).pipe(
      map((r: StrictHttpResponse<WorkflowConditionPublishedWorkflowItemWithRelations>) => r.body as WorkflowConditionPublishedWorkflowItemWithRelations)
    );
  }

  /**
   * Path part for operation workflowConditionPublishedWorkflowItemControllerDeleteById
   */
  static readonly WorkflowConditionPublishedWorkflowItemControllerDeleteByIdPath = '/workflow-condition-published-workflow-items/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteById()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteById$Response(params: {
    id: string;
  }): Observable<StrictHttpResponse<any>> {

    const rb = new RequestBuilder(this.rootUrl, WorkflowConditionPublishedWorkflowItemControllerService.WorkflowConditionPublishedWorkflowItemControllerDeleteByIdPath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<any>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `deleteById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteById(params: {
    id: string;
  }): Observable<any> {

    return this.deleteById$Response(params).pipe(
      map((r: StrictHttpResponse<any>) => r.body as any)
    );
  }

  /**
   * Path part for operation workflowConditionPublishedWorkflowItemControllerFind
   */
  static readonly WorkflowConditionPublishedWorkflowItemControllerFindPath = '/workflow-condition-published-workflow-items';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `find()` instead.
   *
   * This method doesn't expect any request body.
   */
  find$Response(params?: {
    filter?: any;
  }): Observable<StrictHttpResponse<Array<WorkflowConditionPublishedWorkflowItemWithRelations>>> {

    const rb = new RequestBuilder(this.rootUrl, WorkflowConditionPublishedWorkflowItemControllerService.WorkflowConditionPublishedWorkflowItemControllerFindPath, 'get');
    if (params) {
      rb.query('filter', params.filter, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkflowConditionPublishedWorkflowItemWithRelations>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `find$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  find(params?: {
    filter?: any;
  }): Observable<Array<WorkflowConditionPublishedWorkflowItemWithRelations>> {

    return this.find$Response(params).pipe(
      map((r: StrictHttpResponse<Array<WorkflowConditionPublishedWorkflowItemWithRelations>>) => r.body as Array<WorkflowConditionPublishedWorkflowItemWithRelations>)
    );
  }

  /**
   * Path part for operation workflowConditionPublishedWorkflowItemControllerCreate
   */
  static readonly WorkflowConditionPublishedWorkflowItemControllerCreatePath = '/workflow-condition-published-workflow-items';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `create()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  create$Response(params?: {
    body?: NewWorkflowConditionPublishedWorkflowItem
  }): Observable<StrictHttpResponse<WorkflowConditionPublishedWorkflowItem>> {

    const rb = new RequestBuilder(this.rootUrl, WorkflowConditionPublishedWorkflowItemControllerService.WorkflowConditionPublishedWorkflowItemControllerCreatePath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkflowConditionPublishedWorkflowItem>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `create$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  create(params?: {
    body?: NewWorkflowConditionPublishedWorkflowItem
  }): Observable<WorkflowConditionPublishedWorkflowItem> {

    return this.create$Response(params).pipe(
      map((r: StrictHttpResponse<WorkflowConditionPublishedWorkflowItem>) => r.body as WorkflowConditionPublishedWorkflowItem)
    );
  }

}
